import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { PolygonSelectorWithLevelsService } from '../../Services/polygon-selector-with-levels.service';
import { HierarchyLevel, SelectionHistoryItem, SelectionChangeEvent} from '../../models/polygon-selector-with-levels.models';
import { PolygonSelectorWithLevelsHighPotentialZonesService } from '../../Services/polygon-selector-with-levels-higPotentialZones.service';
import { IPolygonSelectorWithLevelsService } from '../../models/polygon-selector-with-levels.interface';
import { PolygonSelectorServiceType } from '../../helpers/EnumSelectorServices';

@Component({
  selector: 'polygon-selector-with-levels',
  templateUrl: './polygon-selector-with-levels.component.html',
  styleUrls: ['./polygon-selector-with-levels.component.css'],
  providers: [ PolygonSelectorWithLevelsService, PolygonSelectorWithLevelsHighPotentialZonesService ]
})
export class PolygonSelectorWithLevelsComponent implements OnInit, OnDestroy {
  

  @Input() hierarchyLevels: HierarchyLevel[] = [];  
  @Input() sourcePrefix: string = '';
  
  @Input() autoLoad: boolean = true;
  @Input() isSelectionActive: boolean = true;
  
  @Input() serviceType: PolygonSelectorServiceType = PolygonSelectorServiceType.Default;
  @Input() useExternalLayers: boolean = false;


  @Output() selectionChange = new EventEmitter<SelectionChangeEvent>();
  @Output() levelBack = new EventEmitter<SelectionChangeEvent>();
  @Output() levelReset = new EventEmitter<void>();

  private isInitialized: boolean = false;
  private selectorService: IPolygonSelectorWithLevelsService;

  constructor(
    private defaultService: PolygonSelectorWithLevelsService,
    private highPotentialZonesService: PolygonSelectorWithLevelsHighPotentialZonesService
  ) {}

  async ngOnInit(): Promise<void> {
    // aqui se puede switchear a otros servicios si hay más opciones
    this.selectorService = this.serviceType === PolygonSelectorServiceType.Potential_Zones ? this.highPotentialZonesService : this.defaultService;

    if (this.hierarchyLevels.length == 0) {
      console.log('selector, no hay nivles de jerarquia');
      return;
    }

    this.selectorService.configure( this.hierarchyLevels, this.sourcePrefix);
    
    // este callback se llama cada vez que cambia la selección
    this.selectorService.onSelectionChange((history, selectedFeature) => {
      const currentLevelIndex = this.selectorService.getCurrentLevelIndex();
      
      const event: SelectionChangeEvent = {
        history: history,
        currentSelection: history.length > 0 ? history[history.length - 1] : null,
        currentLevelIndex: currentLevelIndex,
        selectedFeature: selectedFeature
      };
      
      this.selectionChange.emit(event);
    });

    await this.selectorService.initialize(this.useExternalLayers);
    this.isInitialized = true;

    if (this.autoLoad) {
      this.loadInitialLevel();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isSelectionActive'] && !changes['isSelectionActive'].firstChange && this.isInitialized) {
      const isActive = changes['isSelectionActive'].currentValue;
      this.selectorService.setSelectionActive(isActive);
    }
  }

  ngOnDestroy(): void {
    console.log("selector, me destruyo");
    
    this.resetToInitialLevel(true);
    this.selectorService?.destroy();
  }

  async loadInitialLevel(): Promise<void> {
    await this.selectorService.loadInitialLevel();
  }

  async goToPreviousLevel(): Promise<void> {
    await this.selectorService.goToPreviousLevel();
    
    const history = this.selectorService.getSelectionHistory();
    const currentLevelIndex = this.selectorService.getCurrentLevelIndex();
    
    const event: SelectionChangeEvent = {
      history,
      currentSelection: history.length > 0 ? history[history.length - 1] : null,
      currentLevelIndex,
      selectedFeature: null
    };
    
    this.levelBack.emit(event);
  }
  
  //estas se puede llamar desde el componente papá
  async resetToInitialLevel(resetAll: boolean): Promise<void> {
    await this.selectorService.resetToInitialLevel(resetAll);
    this.levelReset.emit();
  }
  
  getSelectionHistory(): SelectionHistoryItem[] {
    return this.selectorService.getSelectionHistory();
  }
  
  getCurrentLevelIndex(): number {
    return this.selectorService.getCurrentLevelIndex();
  }
  
  canGoBack(): boolean {
    return this.selectorService.getCurrentLevelIndex() > 0;
  }
  
  isLastLevel(): boolean {
    return this.selectorService.getCurrentLevelIndex() === this.hierarchyLevels.length - 1;
  }

  restoreFullGeoJsonForCurrentLevel(): void {
    this.selectorService.restoreFullGeoJsonForCurrentLevel();
  }
}
